import React from 'react';
import '../css/SystemIntegrator.css';
// import Icon from 'react-icons-kit';
// import { iosPlusEmpty } from 'react-icons-kit/ionicons';
import Modal from 'react-modal';
import PieChart from './PieChart';
import PieChartNew from './PieChartNew';
import DoughnutChart from './DoughnutChart';
import SIProjects from './SIProjects';
import Sorting from './Sorting';
import Cookies from 'js-cookie';
import SystemIntegratorView from './SystemIntegratorView';
import SystemIntegratorEdit from './SystemIntegratorEdit';
import SystemIntegratorAddNew from './SystemIntegratorAddNew';

import SearchBar from './SearchBar';
import Style from 'style-it';
// import ReactTooltip from 'react-tooltip'
import { Tooltip } from 'react-tooltip';

import minus from './../assets/images/minus.svg'
import plus from './../assets/images/plus.svg'
import edit from './../assets/images/edit.svg'
import view from './../assets/images/view.svg'
import totalBoxes from '../assets/images/totalBoxes.svg';
import totalProjects from '../assets/images/totalProjects.svg';
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
import SiTotalOkasBoxes from './SiTotalOkasBoxes';
import Loader from './Loader';


//system intregator dashboard page.

const customStylesDelete = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    minHeight: '40%',
    overflow: 'auto',
    padding: '2%',
  }
};

const styles = theme => ({
  root: {
    display: 'flex',
    // flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: 120,
    width: '100%',
    border: 'none'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
    width: '100%',
  },
});
class OkasAdditionalInventoryRequest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpenAddSI: false,
      modalIsOpenAddSIView: false,
      modalIsOpenSIProject: false,
      modalIsOpenOkasBoxes: false,
      modalIsOpenAddSIEdit: false,
      boxesBySi: [],
      siData: [],
      actualData: [],
      searchValue: '',
      siProjectAddress: [],
      currentViewAllProjects: [],
      currentViewAllBoxes: [],
      siTotalProjectPieChart: 0,
      siTotalBoxesPieChart: 0,
      selectedLocation: '',
      sortingStatus: {
        sortingName: '',
        defaultDown:  true
      },
      loader: true,
      snackbarActive: false,
      snackbarMessage: ''
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalDelete = this.closeModalDelete.bind(this);
  }

  openModal() {
    this.setState({
      modalIsOpenAddSI: false
    }, () => {
      this.setState({
        modalIsOpenAddSI: true
      })
    })
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({ modalIsOpenAddSI: false });
  }

  closeModalDelete() {
    this.setState({
      modalIsOpenDelete: false
    });
  }

  restoreData = (data) => {
    this.setState({
      siData: data,     
    })
  }


resetSearchBar = () =>{
  this.props.searchBarActivate(false)
}


sortingFunc = (type, searchValue) => {
  if (type !== 'search') {
    if (this.state.sortingStatus.sortingName === type) {
      this.setState({
        sortingStatus: {
          sortingName: type,
          defaultDown: !this.state.sortingStatus.defaultDown
        },
      }, () => {
        if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
          Sorting(this.restoreData, type, this.state.siData.sort());
          // Sorting(this.restoreData, type, this.state.actualData);
        } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
          Sorting(this.restoreData, 'reverse', this.state.siData.sort());
        }
      })
    } else {
      this.setState({
        sortingStatus: {
          sortingName: type,
          defaultDown: true
        },
      }, () => {
        if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
          Sorting(this.restoreData, type, this.state.siData.sort());
          // Sorting(this.restoreData, type, this.state.actualData);
        } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
          Sorting(this.restoreData, 'reverse', this.state.siData.sort());
        }
      })
    }
  } else if (type === 'search') {
    type = 'search';
    Sorting(this.restoreData, type, this.state.actualData, searchValue);
  } else {
    type = 'reverse';
    Sorting(this.restoreData, type, this.state.actualData);
  }
}



  ActivateSIModel = (e) => {
    if (this.state.modalIsOpenAddSI) {
      return <SystemIntegratorAddNew activeModal={true} closeAllModal={this.closeAllModal.bind(this)} />
    } else {
      return null
    }
  }

  ActivateSiModelView = (e) => {
    if (this.state.modalIsOpenAddSIView) {
      return <SystemIntegratorView activeModal={true} siCurrentData={this.state.siCurrentData} closeAllModal={this.closeAllModal.bind(this)} />
    } else {
      return null
    }
  }

  ActivateSiModelEdit = (e) => {
    if (this.state.modalIsOpenAddSIEdit) {
      return <SystemIntegratorEdit activeModal={true} siCurrentData={this.state.siCurrentData} closeAllModal={this.closeAllModal.bind(this)} />
    } else {
      return null
    }
  }

  componentDidMount() {
    this.resetSearchBar()
    this.fetchDevices();
    this.fetchBoxes()
    // this.fetchLocations();
    // this.fetchAllBoxes()
  }

  onDeleteFinal = (e) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }

    fetch(`/cloud/si_IntegratorApi_Detail/${this.state.itemToDeleteId}`, {
      method: "DELETE",
      headers: headers,
      body: JSON.stringify({ hello: "hello" })
    })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .catch((err)=>{
        console.log(err)
      })
  }

  renderTotalProject = () => {
    if (this.state.modalIsOpenSIProject) {
      return <SIProjects activeModal={true} siCurrentData={this.state.siCurrentData} siAllProjectData={this.state.currentViewAllProjects} closeAllModal={this.closeAllModal.bind(this)} />
    } else {
      return null
    }
  }

  renderTotalBoxes = () => {
    if (this.state.modalIsOpenOkasBoxes) {
      return <SiTotalOkasBoxes activeModal={true} siCurrentData={this.state.siCurrentData} SiTotalOkasBoxes={this.state.currentViewAllBoxes} closeAllModal={this.closeAllModal.bind(this)}/>
    } else {
      return null
    }
  }


  fetchDevices = () => {
    this.setState({
      loader: true
    })
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/si_IntegratorApi/', {
      method: "GET",
      headers: headers,
    })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {
        this.setState({
          siData: data,
          actualData: data,
          loader: false
        })
      })
      .catch((err)=>{
        console.log(err)

      })
  }

  restoreData = (data) => {
    this.setState({
      siData: data
    })
  }

  fetchBoxesBySI = (siID) => {
    let boxesBySi = [];
    this.state.okasBoxes.forEach((element) => {
      if (Number(element.okasBox_assigned_to) === Number(siID)) {
        boxesBySi.push(element)
      }
    });
    this.setState({ boxesBySi })
  }

  fetchLocations = (siId) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/all_loc_details/', {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ si_id: siId })
    })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {
        console.log(data)
        this.setState({
          siProjectAddress: data
        })
      })
      .catch((err)=>{
        console.log(err)
      })
  }

  fetchAllProjectsSI = (siEmail) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    let bodyToQuery = {
      'user': siEmail
    }
    console.log(bodyToQuery)
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch(`/cloud/projectdetails/`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(bodyToQuery)
    })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {
        console.log(data)
        let noOfProjects = data.length;
        let noOfBoxes = 0;
        if(true){       
        data.forEach((firstElement) => {
          noOfBoxes = noOfBoxes + firstElement.total_number_of_okas_box
        })
        this.setState({
          siTotalProjectPieChart: noOfProjects,
          siTotalBoxesPieChart: noOfBoxes,
          currentViewAllProjects: data
        },()=>{
          if(this.state.selectedLocation!==''){
            this.fetchAllBoxes(this.state.siSelected)
          }
        })
      }      
      })
  }

  fetchProjects = (si_id, loc_id) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/view_all_projects_location_wise/', {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        si_id: si_id,
        loc_id: loc_id
      })
    })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {
        this.setState({
          currentViewAllProjects: data
        })
      })
      .catch((err)=>{
        console.log(err)
      })
  }

  sortingFunc = (type, searchValue) => {
    if (type !== 'search') {
      if (this.state.sortingStatus.sortingName === type) {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: !this.state.sortingStatus.defaultDown
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.siData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.siData.sort());
          }
        })
      } else {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: true
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.siData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.siData.sort());
          }
        })
      }
    } else if (type === 'search') {
      type = 'search';
      Sorting(this.restoreData, type, this.state.actualData, searchValue);
    } else {
      type = 'reverse';
      Sorting(this.restoreData, type, this.state.actualData);
    }
  }

  fetchIconType = (e) =>{
    if(e===this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown){
      return 'fas fa-chevron-down pointer ml-2 float-right'
    }else if(e===this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown){
      return 'fas fa-chevron-up pointer ml-2 float-right'
    }else{
      return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
    }
  }

  fetchRespectiveBoxes = (si_id, loc_id) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/allOkasBoxes/', {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        si_id: si_id,
        loc_id: loc_id
      })
    })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {
        this.setState({
          currentViewAllBoxes: data
        })
      })
      .catch((err)=>{
        console.log(err)
      })
  }
  fetchAllBoxes = (si_id) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/siallboxes/', {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        si_id: si_id,
      })
    })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {
        this.setState({
          currentViewAllBoxes: data,
          siTotalBoxesPieChart: data.length

        })
      })
      .catch((err)=>{
        console.log(err)
        console.log(err)

      })
  }

  fetchBoxes = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/okasBoxApi/', {
      method: "GET",
      headers: headers,
    })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {
        this.setState({
          okasBoxes: data
        })
      })
      .catch((err)=>{
        console.log(err)

      })
  }




  selectedLocationStatus = (selectedLocation, type) => {
    if (this.state.selectedLocation === selectedLocation && type === 'location') {
      return 'bolder'
    } else if (type === 'username' && this.state.selectedLocation === '') {
      return 'bolder'
    } else {
      return 'normal'
    }
  }

  siDatatable = () => {
    let totalBoxesIcon = <img src={totalBoxes} />;
    let totalProjectsIcon = <img src={totalProjects} />;
    if (this.state.siData !== null) {
      let someData = this.state.siData.map((siElement, index) => {
        return (
          <React.Fragment>
            <tr key={index} className="some-hover" style={{ backgroundColor: this.state.siSelected === index ? '#F2F2E9' : '' }}>
              {/* <th scope="col" style={{ width: '50px', verticalAlign: 'middle' }} >
                {this.state.siSelected === index ? <img src={minus} style={{
                  verticalAlign: 'middle', marginLeft: '10px',
                }}
                  onClick={(e) => {
                    this.fetchBoxesBySI(siElement.si_id);
                    this.setState({
                      selectedLocation: '',
                      siProjectAddress: [],
                    }, () => {
                      this.fetchLocations(siElement.si_id);
                      this.fetchAllProjectsSI(siElement.si_email);
                      this.fetchAllBoxes(siElement.si_id)
                      if (this.state.siSelected === index) {
                        this.setState({
                          siSelected: '',
                        })
                      } else {
                        this.fetchLocations(siElement.si_id);
                        this.fetchAllBoxes(siElement.si_id)
                        this.fetchAllProjectsSI(siElement.si_email);
                        this.setState({
                          siSelected: index,
                        })
                      }
                    })
                  }}
                /> : <img src={plus} style={{ verticalAlign: 'middle', marginLeft: '10px' }}
                  onClick={(e) => {
                    this.fetchBoxesBySI(siElement.si_id);
                    this.setState({
                      selectedLocation: '',
                      siProjectAddress: [],
                    }, () => {
                      this.fetchLocations(siElement.si_id);
                      this.fetchAllProjectsSI(siElement.si_email);
                      this.fetchAllBoxes(siElement.si_id)
                      if (this.state.siSelected === index) {
                        this.setState({
                          siSelected: '',
                        })
                      } else {
                        this.fetchLocations(siElement.si_id);
                        this.fetchAllBoxes(siElement.si_id)
                        this.fetchAllProjectsSI(siElement.si_email);
                        this.setState({
                          siSelected: index,
                        })
                      }
                    })
                  }}
                  />}
              </th> */}
               <th scope="col" style={{ width: '80px', wordBreak: 'break-word', verticalAlign: 'middle', wordWrap: 'break-word' }} >{siElement.si_id}</th>
              <th scope="col" style={{ width: '9.6%', wordBreak: 'break-word', verticalAlign: 'middle', wordWrap: 'break-word' }} >{siElement.si_id}</th>
              <td scope="col" style={{ width: '15%', verticalAlign: 'middle', wordBreak: 'break-word', wordWrap: 'break-word' }}>{siElement.si_name}</td>
              <td scope="col" style={{ width: '15%', verticalAlign: 'middle', wordBreak: 'break-word', wordWrap: 'break-word' }}>{siElement.si_company}</td>
              <td scope="col" style={{ width: '100px', wordBreak: 'break-word', verticalAlign: 'middle', wordWrap: 'break-word' }}>{siElement.si_area}</td>
              <td scope="col" style={{ wordBreak: 'break-word',textAlign:'center', verticalAlign: 'middle', width: '140px', minWidth: '70px', wordWrap: 'break-word' }}>{siElement.si_rating}</td>
              <td scope="col" style={{ wordBreak: 'break-word', textAlign:'center',verticalAlign: 'middle', width: '70px', wordWrap: 'break-word' }}>{siElement.si_relationstatus}</td>
              <td style={{  width: '120px', verticalAlign: 'middle' }}>
                <span onClick={
                  (e) => {
                    if (this.state.modalIsOpenAddSIView) {
                      this.setState({ modalIsOpenAddSIView: false }, () => {
                        this.setState({
                          modalIsOpenAddSIView: true,
                          siCurrentData: siElement,
                          siSelected: ''
                        })
                      })
                    } else {
                      this.setState({
                        modalIsOpenAddSIView: true,
                        siCurrentData: siElement
                      })
                    }
                  }}>
                  <img src={view} alt="" style={{ width: '16px', height: '16px', marginRight: '15px' }} />
                </span>
                <span
                  onClick={
                    (e) => {
                      if (this.state.modalIsOpenAddSIEdit) {
                        this.setState({ modalIsOpenAddSIEdit: false }, () => {
                          this.setState({
                            modalIsOpenAddSIEdit: true,
                            siCurrentData: siElement,
                            siSelected: ''
                          })
                        })
                      } else {
                        this.setState({
                          modalIsOpenAddSIEdit: true,
                          siCurrentData: siElement
                        })
                      }
                    }}
                >
                  <img src={edit} alt="" style={{ width: '16px', height: '16px', marginLeft: '15px' }} />
                </span>
              </td>
            </tr>
            {this.state.siSelected === index ? <tr style={{ overflow: 'hidden', display: this.overlayShadowUnderModal('siCurrentDataBlock') }} className="SiCurrentData animated fadeIn " >
              <td colSpan={3}>
                <div class="wrapper">
                  <ul class="StepProgress" style={{ backgroundColor: 'transparent', wordBreak: 'break-word' }}>
                    < li class="StepProgress-item is-done pointer" style={{ fontWeight: this.selectedLocationStatus('username', 'username'), float: "none"  }}
                      onClick={(e) => {
                        this.fetchLocations(siElement.si_id);
                        this.fetchAllBoxes(siElement.si_id)
                        this.fetchAllProjectsSI(siElement.si_email);
                        this.setState({
                          selectedLocation: ''
                        })
                      }}>
                      <span style={{ color: '#00B0A9', fontSize: '20px', fontWeight: 'normal' }}> {siElement.si_name}<br /></span>
                      {siElement.si_email}
                    </li>
                    {this.state.siProjectAddress.map((firstElement) => {
                      return (
                        <li
                          class="StepProgress-item is-done pointer"
                          key={firstElement}
                          style={{ fontWeight: this.selectedLocationStatus(firstElement.location, 'location'),}}
                          onClick={(e) => {
                            this.fetchProjects(siElement.si_id, firstElement.ID)
                            this.fetchRespectiveBoxes(siElement.si_id, firstElement.ID)
                            this.setState({
                              siTotalBoxesPieChart: firstElement.installed_box,
                              siTotalProjectPieChart: firstElement.project_count,
                              selectedLocation: firstElement.location
                            })
                          }}
                        >
                          {firstElement.location}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </td>
              <td colSpan={5} className="text-center">
                <div className="row">
                  <div className="col-6">
                    <PieChartNew
                      percent={this.state.siTotalProjectPieChart}
                      chartWidth={window.screen.availWidth / 10}
                      displayBackgroundColor='#F2F2E9'
                      icon={totalProjectsIcon}
                      strokeWidth={6.5}
                      label="Total Projects"
                      strokeColor='#f07e25'
                      percentLabel="Projects"
                      percentFontSize={`${window.screen.availWidth / 500}rem`}
                      percentLabelSize={`${window.screen.availWidth / 1500}rem`}
                      percentLabelTop="60%"
                      percentTop="22%"
                      fontWeight="650"
                    />
                    <a style={{ pointerEvents: this.state.siTotalProjectPieChart === 0 ? 'none' : '', color: this.state.siTotalProjectPieChart === 0 ? '' : '#00B0A9' }} onClick={(e) => {
                      if (this.state.modalIsOpenSIProject) {
                        this.setState({ modalIsOpenSIProject: false }, () => {
                          this.setState({
                            modalIsOpenSIProject: true,
                            siCurrentData: siElement,
                            siSelected: ''
                          })
                        })
                      } else {
                        this.setState({
                          modalIsOpenSIProject: true,
                          siCurrentData: siElement
                        })
                      }
                    }}
                    >View All</a>
                  </div>
                  <div className="col-6">
                    <PieChartNew
                      // percent={this.state.siTotalBoxesPieChart}
                      percent={this.state.currentViewAllBoxes.length}
                      chartWidth={window.screen.availWidth / 10}
                      displayBackgroundColor='#F2F2E9'
                      icon={totalBoxesIcon}
                      strokeWidth={6.5}
                      label="No of OKAS Boxes"
                      strokeColor='#f07e25'
                      percentLabel="Boxes"
                      percentFontSize={`${window.screen.availWidth / 500}rem`}
                      percentLabelSize={`${window.screen.availWidth / 1500}rem`}
                      percentLabelTop="60%"
                      percentTop="22%"
                      fontWeight="650"
                    />
                    {/* <a style={{ pointerEvents: this.state.siTotalBoxesPieChart === 0 ? 'none' : '', color: this.state.siTotalBoxesPieChart === 0 ? '' : '#00B0A9' }} onClick={(e) => { */}
                    <a style={{ pointerEvents: this.state.currentViewAllBoxes.length === 0 ? 'none' : '', color: this.state.currentViewAllBoxes.length === 0 ? '' : '#00B0A9' }} onClick={(e) => {
                      if (this.state.modalIsOpenOkasBoxes) {
                        this.setState({ modalIsOpenOkasBoxes: false }, () => {
                          this.setState({
                            modalIsOpenOkasBoxes: true,
                            siCurrentData: siElement,
                            siSelected: ''
                          })
                        })
                      } else {
                        this.setState({
                          modalIsOpenOkasBoxes: true,
                          siCurrentData: siElement
                        })
                      }
                    }}
                    >View All</a>
                  </div>
                </div>
              </td>
            </tr> : null}
          </React.Fragment>
        )
      })
      return someData;
    }
    else {
      return null
    }
  }

  overlayShadowUnderModal = (type) => {
    if (type === 'overlay') {
      if (this.state.modalIsOpenAddSI || this.state.modalIsOpenAddSIView || this.state.modalIsOpenSIProject || this.state.modalIsOpenOkasBoxes || this.state.modalIsOpenAddSIEdit) {
        return (
          <div style={{ position: 'absolute', height: `${window.innerHeight - 60}px`, width: `${window.innerWidth - 260}px`, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: '0', display: '' }}></div>
        )
      } else {
        return null
      }
    } else if (type === 'scroll') {
      return 'hidden'
    } else if (type === 'siCurrentDataBlock') {
      if (this.state.modalIsOpenAddSI || this.state.modalIsOpenAddSIView || this.state.modalIsOpenSIProject || this.state.modalIsOpenOkasBoxes || this.state.modalIsOpenAddSIEdit) {
        return (
         'none'
        )
      }else{
        return null
      }
    }
  }

  closeAllModal = (e) =>{
    this.fetchDevices();
    this.setState({
        modalIsOpenAddSI: false,
        modalIsOpenAddSIView: false,
        modalIsOpenSIProject: false,
        modalIsOpenOkasBoxes: false,
        modalIsOpenAddSIEdit: false,
      })
  }

  render() {
    return (
      <React.Fragment>
         {this.state.loader ? <Loader /> : null}
        {this.overlayShadowUnderModal('overlay')}
        <Tooltip />
        <Style>
          {
            `.atoB {
              position: relative;
              margin:14%
            }            
            .firstDot {
              position: absolute;
              top:  ${this.state.siProjectAddress.length === 0 ? '25%' : '6%'};
              left: 0;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #949494;
            }            
            .secondDott {
              position: absolute;
              top: 70%;
              left: 0;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #949494;
            }
            .text::before {
              content: '';
              border-left: 3px solid #949494;
              width: 10px;
              position: absolute;
              height: ${this.state.siProjectAddress.length === 0 ? '0%' : '86%'};
              top: 9.5%;
              left: 1.5%;
            }            
            .text {
              margin-bottom: 20%;
              margin-left: 10%;
              color: #757575
            }            
            .heading-part1{
              font-size: 1rem;
              color: #000;
            }
            .part2{
              font-size: .75rem;
            }`
          }
        </Style>
        <div style={{ width: '100%', paddingLeft: '5px', paddingTop: '40px', paddingRight: '20px',}}>
          {!this.props.redux.auth.searchBarShow ? <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#888888', fontSize: '30px', }}>ADDITIONAL INVENTORY REQUEST</span>
            <span style={{ float: 'right' }}>
              {!this.props.redux.auth.searchBarShow ? <div className="row" style={{ margin: '0' }}>
                <a href='/okasboxes/dashboard'>
                <div className="pointer">
                  <div className="buttonContent" style={{ backgroundColor: '#2976a7', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)' }}>
                    <span style={{ color: '#FFFFFF', fontSize: '10px', fontWeight: '600' }}>RETURN TO THE MAIN INVENTORY</span>
                  </div>
                </div>
                </a>
              </div> : null}
            </span>
          </div> : <div className='animated animated-duration-custom slideInDown pb-3 mt-2 flex-fill'>
              <SearchBar autoFocus
                value={this.state.searchValue}
                onChange={(e) => {
                  this.setState({
                    searchValue: e
                  }, () => {
                    this.sortingFunc('search', this.state.searchValue)
                  })
                }
                }
                onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
                resetSearch = {(e)=>{
                  this.setState({
                    searchValue: e
                  }, () => {
                    this.sortingFunc('search', '')
                  })
                }}
              /></div>}
          <table className="table">
            <thead className="tableHeaderColor" style={{ borderRadius: '10px 10px 0px 0px' }}>
              {/* <th scope="col" style={{ width: '50px' }}></th> */}
              <th scope="col" style={{ width: '85px', verticalAlign: 'middle', fontSize:'12px' }}> 
                DISTRIBUTOR
                    {/* <i class={this.fetchIconType('si_id')} onClick={(e) => { this.sortingFunc('si_id') }}></i> */}
              </th>
              <th scope="col" style={{ width: '86px', verticalAlign: 'middle',  fontSize:'12px' }}>
                TOTAL QUANTITY
                    {/* <i class={this.fetchIconType('si_name')} onClick={(e) => { this.sortingFunc('si_name') }}></i> */}
              </th>
              <th scope="col" style={{ width: '15%', verticalAlign: 'middle',  fontSize:'12px' }}>
                MASTER STUDIO QTY.
                    {/* <i class={this.fetchIconType('si_company')} onClick={(e) => { this.sortingFunc('si_company') }}></i> */}
              </th>
              <th scope="col" style={{ width: '14%', verticalAlign: 'middle',  fontSize:'12px' }}>
                MEDIA STUDIO QTY.
                    {/* <i class={this.fetchIconType('si_area')} onClick={(e) => { this.sortingFunc('si_area') }}></i> */}
              </th>
              <th scope="col" style={{ width: '109px', verticalAlign: 'middle', fontSize:'12px' }}>
                ULTRA MEDIA STUDIO/X MEDIA STUDIO/MX STUDIO QTY.
                    {/* <i class={this.fetchIconType('si_rating')} onClick={(e) => { this.sortingFunc('si_rating') }}></i> */}
              </th>
              <th scope="col" style={{ width: '150px', verticalAlign: 'middle', fontSize:'12px' }}>
                MUSIC STUDIO/SOUND STUDIO QTY.
                    {/* <i class={this.fetchIconType('si_relationstatus')} onClick={(e) => { this.sortingFunc('si_relationstatus') }}></i> */}
              </th>
              <th scope="col" style={{ width: '70px', verticalAlign: 'middle', fontSize:'12px' }}>
                CONTROL STUDIO QTY.
                </th>
                <th scope="col" style={{ width: '150px', verticalAlign: 'middle', fontSize:'12px' }}>
                REQUEST STATUS
                </th>
            </thead>
            <tbody style={{maxHeight:`${window.innerHeight-295}px`,overflowY: 'overlay'}}>
              {this.siDatatable()}
            </tbody>
          </table>
        </div>
        {this.ActivateSIModel()}
        {this.ActivateSiModelView()}
        {this.ActivateSiModelEdit()}
        {this.renderTotalProject()}
        {this.renderTotalBoxes()}
        <div className="modal">
          <DoughnutChart />
        </div>
        <Modal
          isOpen={this.state.modalIsOpenDelete}
          style={customStylesDelete}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModalDelete}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Are you sure you want to proceed with deletion?</h3>
            <i class="fas  fa-question-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5" onClick={this.onDeleteFinal.bind(this)}>Delete </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    redux: state,
  };
};



const mapDispatchToProps = dispatch => {
  return {
    searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(OkasAdditionalInventoryRequest);